export default __webpack_public_path__ + "static/media/background-6.95c83fc5.png";